<div class="logo" *ngIf="service">
  <a href="/service/{{ service.slug }}"><img src="{{ service.logo }}" alt="{{ service.name }}"></a>
</div>
<mat-card class="mat-card--ticket">
  <app-shared-ticket *ngIf="ticketUid && service" [serviceUid]="service.uid" [ticketUid]="ticketUid" [view]="'service'"></app-shared-ticket>
</mat-card>
